import "./App.css";

import { FaWhatsapp } from "react-icons/fa";

import Header from "./components/Header";
import Nav from "./components/Nav";
import Section from "./components/Section";
import About from "./components/About";
import CTASection from "./components/CTASeciton";
import HTBSection from "./components/HTBSection";
import FeedBacks from "./components/FeedBacks";
import Statics from "./components/Statics";
import Footer from "./components/Footer";

function App() {
  return (
    <div>
      <Header />
      <Nav />
      <Section />
      <HTBSection /> {/* How To Buy */}
      <CTASection /> {/* Call To Action */}
      <About />
      <FeedBacks />
      <Statics />
      <Footer />
      <a
        href="https://wa.me/5544991419595?text=Olá,%20gostaria%20de%20saber%20sobre%20uma%20peça."
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaWhatsapp size={28} color="#fff" />
      </a>
    </div>
  );
}

export default App;
